import styled from 'styled-components'
import Fonts, { family } from 'components/base-ui/Fonts'
import BaseButton from 'components/base-ui/Button'
import media from 'styles/media'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 4px;
  width: 100%;
  padding: 8px;
  border-radius: 8px;
  border: 1px solid #fef1e5;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.32);
`

const Title = styled(Fonts.SmallTitleBold)`
  color: ${({ theme }) => theme.colors.primary};
  @media (${media.screenSmMiniMax}) {
    font-size: 12px;
  }
`

const Button = styled(BaseButton)`
  padding: 4px 10px 4px 10px;
  min-height: 24px;
`

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`

const TitleModal = styled(Fonts.H3)`
  display: flex;
  align-items: center;
  column-gap: 4px;
`

const Description = styled(Fonts.SmallTitleRegular)`
  color: ${({ theme }) => theme.colors.darkGrey};
`

const StepsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
`

const MoreText = styled(Fonts.LinkSmall)`
  flex-grow: 1;
  color: #2e8ce2;
  white-space: nowrap;
`

const CombinedText = styled(Fonts.BaseBold)`
  font-family: ${family.brand};
  white-space: nowrap;
  @media (${media.screenSmMiniMax}) {
    font-size: 12px;
  }
`

export { Wrapper, Title, Button, ModalContent, TitleModal, Description, StepsWrapper, MoreText, CombinedText }
